<template>
    <div class="top-page">
        <div class="top-page__container">
            <div class="top-page__breadcrumbs breadcrumbs">
                <ul class="breadcrumbs__list">
                    <li class="breadcrumbs__item"><a href="" class="breadcrumbs__link">Le'Perle</a></li>
                    <li class="breadcrumbs__item"><span class="breadcrumbs__current">Мій список бажань</span></li>
                </ul>
            </div>
            <div class="top-page__body">
                <h1 class="top-page__title" data-title="my wishlist">Мій список бажань</h1>
                <div class="top-page__control">
                    <button class="top-page__button top-page__button_hide _icon-filter" @click="toggleOpenFilter">Фільтри</button>
                </div>
            </div>
        </div>
    </div>

    <section class="favorite-page">
        <div class="favorite-page__container">
            <div class="favorite-page__items product-items">
                <ProductCartFavorite v-for="(product, index) in wishlistProducts" :key="index" :product="product" @removedFromWishlist="getWishlistProducts" />
            </div>
        </div>
    </section>

    <ProductSlider :title="'Інші клієнти також купили'" :products="viewedProducts" id="1" />
    <ProductSlider :title="'Останні переглянуті товари'" :products="viewedProducts" id="2" />
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ProductCartFavorite, ProductSlider } from "#components";

const isFilterOpen = ref(false);
const viewedProducts = ref([]);
const wishlistProducts = ref([]);

const toggleOpenFilter = () => {
    isFilterOpen.value = !isFilterOpen.value;
};

const getViewProducts = () => {
    let storedProducts = localStorage.getItem("viewedProducts");
    if (storedProducts) {
        viewedProducts.value = JSON.parse(storedProducts);
    }
};

const getWishlistProducts = () => {
    let storedProducts = localStorage.getItem("wishlist");
    if (storedProducts) {
        wishlistProducts.value = JSON.parse(storedProducts);
    } else {
        wishlistProducts.value = [];
    }
};

onMounted(() => {
    getViewProducts();
    getWishlistProducts();
});
</script>

<style></style>
